import type React from "react";
import intl from "react-intl-universal";
import { EmptyState } from "../styled";

const NotificationsEmptyState: React.FC = () => (
  <EmptyState>{intl.get("masterdataAutomationNotifications.emptyState")}</EmptyState>
);

export default NotificationsEmptyState;
